import {useRef} from "react";


/*
hook for handling enter and escape to trigger buttons.
elements that are passed the submitRef are 'clicked' on 'enter',
dito for cancelRef and 'escape'.
a function 'onKey' forwards events to this component.
additionally a ref 'handleEvent' is provided for handling events, the return value of which
is used to decide whether an event should be handled.
 */
const useSubmitCancel = (handleEv = ev => true) => {
    const submitRef = useRef();
    const cancelRef = useRef();

    // ignore the event if handleEvent says so
    const handleEvent = useRef(handleEv);

    // expose a function to update the ref so we can handle default fallback here
    // instead of clients having to
    const handleIf = (test = ev => true) => {
        handleEvent.current = test;
    };

    const onKey = ev => {
        let handled = false;

        if (submitRef.current && ev.key === 'Enter' && handleEvent.current(ev)) {
            submitRef.current.click();
            handled = true;
        }
        else if (cancelRef.current && ev.key === 'Escape' && handleEvent.current(ev)) {
            cancelRef.current.click();
            handled = true;
        }

        if (handled) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };

    // return [submitRef, cancelRef, onKey, handleEvent];
    return [submitRef, cancelRef, onKey, handleIf];
};

export default useSubmitCancel;
